import {
  BILLING_SYSTEM_FETCH_REQUEST,
  BILLING_SYSTEM_FETCH_REQUEST_SUCCESS,
  BILLING_SYSTEM_FETCH_REQUEST_FAILURE,
  BILLING_SYSTEM_CLEAN_REQUEST,
} from '../constants/actionTypes';

const INITIAL_STATE = {
  payload: [],
  loading: false,
  errors: {},

  pagination: {
    current: 0,
    pageSize: 0,
    total: 0,
    totalPage: 0,
  },
};

/**
 * A reducer takes two arguments, the current state and an action.
 */
const billingSystemReducer = (state, action) => {
  state = state || INITIAL_STATE;

  switch (action.type) {
    case BILLING_SYSTEM_FETCH_REQUEST:
      return Object.assign({}, state, {
        loading: true,
      });

    case BILLING_SYSTEM_FETCH_REQUEST_SUCCESS:
      return Object.assign({}, state, {
        loading: false,
        payload: action.data.data,
        errors: {},
        pagination: {
          current: action.data?.currentPage,
          pageSize: action.data?.pageSize,
          total: action.data?.totalRecord,
          totalPage: action.data?.totalPage,
        },
      });

    case BILLING_SYSTEM_FETCH_REQUEST_FAILURE:
      return Object.assign({}, state, {
        loading: false,
        errors: action.error,
      });

    case BILLING_SYSTEM_CLEAN_REQUEST:
      return Object.assign({}, state, {
        payload: [],
        loading: false,
        errors: {},
        pagination: {
          current: 0,
          pageSize: 0,
          total: 0,
          totalPage: 0,
        },
      });

    default:
      return state;
  }
};

export default billingSystemReducer;
